import script from "./ExclusionList.vue?vue&type=script&setup=true&lang=js"
export * from "./ExclusionList.vue?vue&type=script&setup=true&lang=js"

import "./ExclusionList.vue?vue&type=style&index=0&id=0980c3dc&lang=css"

const __exports__ = script;

export default __exports__